import { render, staticRenderFns } from "./GdprBottomComponent.vue?vue&type=template&id=78072264"
import script from "./GdprBottomComponent.vue?vue&type=script&lang=js"
export * from "./GdprBottomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports